import * as React from 'react';
import { Avatar } from 'ui/avatar/Avatar';
import { useUserData } from 'components/user/hooks/use-user-data';
import { UserPanelBalance } from '../user-panel/UserPanelBalance';

var ProfileInfo = function ProfileInfo() {
  var userData = useUserData();
  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-header__avatar avatar"
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: userData.avatar.image
  })), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-header__data"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text text_lg text-truncate"
  }, userData.fullName), /*#__PURE__*/React.createElement("div", {
    className: "text text-truncate color-858585"
  }, userData.email)), /*#__PURE__*/React.createElement(UserPanelBalance, null));
};

export { ProfileInfo };